module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "180px"
    }
  }, [_c('div', {
    staticClass: "block_1 flex-row"
  }, [_c('advance-search', {
    attrs: {
      "dialogVisible": _vm.showAdSearch
    },
    on: {
      "closeDialog": _vm.closeAdvanceSearch,
      "openLink": _vm.jumpgoStatic
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "image_1",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("../../src/assets/logo.png")
    },
    on: {
      "click": function($event) {
        return _vm.jumpgo('/nav')
      }
    }
  }), _vm._v(" "), (!_vm.isSelect) ? _c('div', {
    staticClass: "flex-row"
  }, [_c('div', {
    staticClass: "group_1 flex-col"
  }), _vm._v(" "), _c('div', {
    staticClass: " flex-row",
    class: _vm.menuIndex == 0 ? 'group_2' : ''
  }, [_c('span', {
    class: _vm.menuIndex == 0 ? 'text_1' : 'text_2',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.jumpgo('/welcome')
      }
    }
  }, [_vm._v("Guess you like")]), _vm._v(" "), _c('div', {
    staticClass: "block_2 flex-col"
  })]), _vm._v(" "), _c('div', {
    staticClass: " flex-row",
    class: _vm.menuIndex == 0 ? 'group_2' : ''
  }, [_c('span', {
    class: _vm.menuIndex == 0 ? 'text_1' : 'text_2',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.jumpgo('/goods?parentId=173&id=182')
      }
    }
  }, [_vm._v("Fabric")]), _vm._v(" "), _c('div', {
    staticClass: "block_2 flex-col"
  })]), _vm._v(" "), _c('div', {
    staticClass: " flex-row",
    class: _vm.menuIndex == 1 ? 'group_2' : ''
  }, [_c('span', {
    class: _vm.menuIndex == 1 ? 'text_1' : 'text_2',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.jumpgo('/designlist?parentId=3&id=98')
      }
    }
  }, [_vm._v("style library")]), _vm._v(" "), _c('div', {
    staticClass: "block_2 flex-col"
  })]), _vm._v(" "), _c('div', {
    staticClass: " flex-row",
    class: _vm.menuIndex == 2 ? 'group_2' : ''
  }, [_c('span', {
    class: _vm.menuIndex == 2 ? 'text_1 ' : 'text_2',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.jumpgo('/commonChanel')
      }
    }
  }, [_vm._v("Public Showroom")]), _vm._v(" "), _c('div', {
    staticClass: "block_2 flex-col"
  })]), _vm._v(" "), _c('div', {
    staticClass: " flex-row",
    class: _vm.menuIndex == 3 ? 'group_2' : ''
  }, [_c('span', {
    class: _vm.menuIndex == 3 ? 'text_1 ' : 'text_2',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.jumpgo('/privateChanel')
      }
    }
  }, [_vm._v("Private Showroom")]), _vm._v(" "), _c('div', {
    staticClass: "block_2 flex-col"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "group_7 flex-col",
    on: {
      "mouseenter": function($event) {
        _vm.userInfoSel = true
      },
      "mouseleave": function($event) {
        _vm.userInfoSel = false
      }
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.userInfoSel) ? _c('div', {
    staticClass: "box_120 flex-col"
  }, [_c('div', {
    staticClass: "box_130 flex-row justify-between"
  }, [_c('img', {
    staticClass: "label_20",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("../../src/assets/header/cricle.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block_10 flex-col justify-between"
  }, [_c('span', {
    staticClass: "text_280"
  }, [_vm._v(_vm._s(this.userInfo.info.customerName))]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "box_140 flex-col"
  }), _vm._v(" "), _c('div', {
    class: _vm.infoSel == 1 ? 'image-wrapper_10' : '',
    on: {
      "mouseenter": function($event) {
        return _vm.changeUserBtn(1)
      },
      "mouseleave": function($event) {
        return _vm.changeUserBtn(0)
      },
      "click": function($event) {
        return _vm.jumpgo('/userInfo')
      }
    }
  }, [_c('img', {
    staticClass: "image_30",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("../../src/assets/header/personcenter.png")
    }
  })]), _vm._v(" "), _c('div', {
    class: _vm.infoSel == 2 ? 'image-wrapper_10' : '',
    on: {
      "mouseenter": function($event) {
        return _vm.changeUserBtn(2)
      },
      "mouseleave": function($event) {
        return _vm.changeUserBtn(0)
      },
      "click": function($event) {
        return _vm.jumpgo('/privateChanel')
      }
    }
  }, [_c('img', {
    staticClass: "image_40",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("../../src/assets/header/privateshowroom.png")
    }
  })]), _vm._v(" "), _c('div', {
    class: _vm.infoSel == 3 ? 'image-wrapper_10' : '',
    on: {
      "mouseenter": function($event) {
        return _vm.changeUserBtn(3)
      },
      "mouseleave": function($event) {
        return _vm.changeUserBtn(0)
      },
      "click": function($event) {
        return _vm.jumpgo('/history')
      }
    }
  }, [_c('img', {
    staticClass: "image_50",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("../../src/assets/header/browsinghistory.png")
    }
  })]), _vm._v(" "), _c('div', {
    class: _vm.infoSel == 4 ? 'image-wrapper_10' : '',
    on: {
      "mouseenter": function($event) {
        return _vm.changeUserBtn(4)
      },
      "mouseleave": function($event) {
        return _vm.changeUserBtn(0)
      },
      "click": function($event) {
        return _vm.jumpgo('/setting')
      }
    }
  }, [_c('img', {
    staticClass: "image_60",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("../../src/assets/header/securitysettings.png")
    }
  })]), _vm._v(" "), _c('div', {
    class: _vm.infoSel == 5 ? 'image-wrapper_10' : '',
    on: {
      "mouseenter": function($event) {
        return _vm.changeUserBtn(5)
      },
      "mouseleave": function($event) {
        return _vm.changeUserBtn(0)
      },
      "click": function($event) {
        return _vm.jumpgo('/favorite')
      }
    }
  }, [_c('img', {
    staticClass: "image_70",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("../../src/assets/header/myfavorites.png")
    }
  })]), _vm._v(" "), _c('div', {
    class: _vm.infoSel == 6 ? 'image-wrapper_10' : '',
    on: {
      "mouseenter": function($event) {
        return _vm.changeUserBtn(6)
      },
      "mouseleave": function($event) {
        return _vm.changeUserBtn(0)
      },
      "click": _vm._loginOut
    }
  }, [_c('img', {
    staticClass: "image_80",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("../../src/assets/header/logout.png")
    }
  })])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "fenge"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "fenge"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-wrapper_1 flex-col"
  }, [_c('span', {
    staticClass: "text_8"
  }, [_vm._v("VIP")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-wrapper_40 flex-row justify-between"
  }, [_c('span', {
    staticClass: "text_290"
  }, [_vm._v("VIP")]), _vm._v(" "), _c('span', {
    staticClass: "text_300"
  }, [_vm._v("VIP")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "15%"
    }
  }, [_c('span', {
    staticClass: "text_655"
  }, [_vm._v("Home >")]), _vm._v(" "), _c('span', {
    staticClass: "text_755"
  }, [_vm._v("Public Showroom")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fbb7bae","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/headerChanelMenucommon.vue
// module id = 524
// module chunks = 63